/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetVersionHistoryQueryResponse, FilesControllerGetVersionHistoryPathParams, FilesControllerGetVersionHistory401, FilesControllerGetVersionHistory403 } from "../../models/filesController/FilesControllerGetVersionHistory";

function getFilesControllerGetVersionHistoryUrl(id: FilesControllerGetVersionHistoryPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}/versions` as const }  
  return res
}

/**
 * @summary Get version history for a file
 * {@link /api/v1/files/:id/versions}
 */
export async function filesControllerGetVersionHistory(id: FilesControllerGetVersionHistoryPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetVersionHistoryQueryResponse, ResponseErrorConfig<FilesControllerGetVersionHistory401 | FilesControllerGetVersionHistory403>, unknown>({ method : "GET", url : getFilesControllerGetVersionHistoryUrl(id).url.toString(), ... requestConfig })  
  return res.data
}